import React, { useState } from "react";

import axios from "axios";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { IntlShape, WrappedComponentProps, injectIntl } from "react-intl";
import { translateMessage } from "src/app/methods/translateMessage";
import Modal, {
  ModalTitle,
  OutsideClickModes,
} from "../../components/Modal/Modal";
import CustomInput from "../../components/CustomInput/CustomInput";
import { API_URLS } from "../../../utils/API_URLS";
import { parseErrorMessages, showErrorToast } from "../../../utils/methods";

interface Props extends WrappedComponentProps<"intl"> {
  onClose: () => void;
  taskId: string;
  publicationUrl?: string;
  intl: IntlShape;
}

function UpdatePublicationLinkModal(props: Props) {
  const { onClose, taskId, publicationUrl, intl } = props;

  const [value, setValue] = useState<string>(publicationUrl || "");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await axios.put(API_URLS.setPublicationMetaValue, {
        taskUuid: taskId,
        publicationUrl: value,
      });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.data?.errors) {
        const errorMessage = parseErrorMessages(error.response.data.errors)[0]
          .message;
        showErrorToast({
          id: errorMessage,
          defaultMessage: errorMessage,
        });
      } else {
        showErrorToast({
          id: "ws_something_wrong_with_updating_link",
          defaultMessage: "Something went wrong during updating link",
        });
      }
    } finally {
      onClose();
    }
  };

  return (
    <Modal
      className="update-publication-link-modal"
      onClose={onClose}
      displayCancelButton
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      onConfirmClick={handleSubmit}
      confirmButtonDisabled={value.length === 0}
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle>
        {publicationUrl ? (
          <IDHFormattedMessage
            id="ws_edit_publication_link"
            defaultMessage="Edit Publication Link"
          />
        ) : (
          <IDHFormattedMessage
            id="ws_add_publication_link"
            defaultMessage="Add Publication Link"
          />
        )}
      </ModalTitle>
      <form onSubmit={handleSubmit}>
        <CustomInput
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={translateMessage({
            intl,
            id: "ws_enter_publication_link",
            defaultMessage: "Enter publication link",
          })}
          fullWidth
        />
      </form>
    </Modal>
  );
}

export default injectIntl(UpdatePublicationLinkModal);
